import React from 'react';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { BaseTable } from 'modules/proposals';
import { Proposal } from '@trnsact/trnsact-shared-types';
import { environmentName } from 'config';
import { useSelector } from 'react-redux';

interface Props {
  customerProposals: Proposal[];
}

export const ProposalsCard = ({ customerProposals }: Props) => {
  const account = useSelector((state: any) => state.account);

  const handleGoToProposalDetail = (proposal: Proposal) => {
    window.open(
      `https://app${
        environmentName === 'dev' ? '.dev' : ''
      }.trnsact.com/ps/?vendorGUID=${account.dynamicsAccountId}&proposalId=${proposal.proposalId}&viewOnly=true`,
      '_blank'
    );
  };

  const handleGoToProposal = (proposal: Proposal) => {
    window.open(`/proposalDetail/${proposal.proposalId}?from=/vo/${proposal.vendorOpportunityId}`, '_blank');
  };

  return (
    <CardContainer title="Proposals">
      <BaseTable
        onGoToProposal={handleGoToProposal}
        onGoToProposalDetail={handleGoToProposalDetail}
        tableData={customerProposals}
      />
    </CardContainer>
  );
};
